import './style.scss';

import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../ui/carousel';
import Text from '../ui/text';
import ProductImage from '../ui/productImage';
import ProductItem from '../productItem';
import { url as productUrl } from 'shared/models/product';

function Recommendations(props) {
  return props.thumbnail ? (
    <ThumbnailRecommendations {...props} />
  ) : (
    <ProductItemRecommendations {...props} />
  );
}

function ThumbnailRecommendations(props) {
  const slidesToShow = props.slidesToShow || 7;
  const slidesToScroll = props.slidesToScroll || 7;
  const responsive = props.responsive || [
    { breakpoint: 1024, settings: { slidesToShow: 5, slidesToScroll: 5 } },
    { breakpoint: 800, settings: { slidesToShow: 7, slidesToScroll: 7 } },
    { breakpoint: 512, settings: { slidesToShow: 5, slidesToScroll: 5 } },
    { breakpoint: 384, settings: { slidesToShow: 4, slidesToScroll: 4 } }
  ];

  const sliderSettings = {
    slidesToShow,
    slidesToScroll,
    responsive,
    lazyLoad: false
  };

  const className =
    'recommendations--thumbnail' +
    (props.className ? ` ${props.className}` : '');

  const list = props.list || [];

  const thumbnail = product => (
    <ProductImage
      product={product}
      loading={props.loading}
      className="recommendations--thumbnail__img"
      title={product.title + ' ' + product.subtitle}
    />
  );

  const containerClass = 'recommendations--thumbnail__img-container';

  const linkStyle = props.loading ? { pointerEvents: 'none' } : {};

  const linkItem = product => (
    <Link
      key={product.sku_id}
      className={containerClass}
      to={productUrl(product)}
      style={linkStyle}
    >
      {thumbnail(product)}
    </Link>
  );

  const plainItem = product => (
    <div
      key={product.sku_id}
      className={containerClass}
      onClick={() => props.onClick(product)}
    >
      {thumbnail(product)}
    </div>
  );

  return (
    <div className={className}>
      {!!props.title && (
        <Text
          title
          tag="h3"
          className="recommendations--thumbnail__heading"
          weight="med"
        >
          {props.title}
        </Text>
      )}
      <Carousel {...sliderSettings} compact>
        {props.link ? list.map(linkItem) : list.map(plainItem)}
      </Carousel>
    </div>
  );
}

function ProductItemRecommendations(props) {
  const sliderSettings = {
    slidesToShow: props.slidesToShow || 7,
    slidesToScroll: props.slidesToScroll || 7,
    responsive: props.responsive || [
      { breakpoint: 1024, settings: { slidesToShow: 5, slidesToScroll: 5 } },
      { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 4 } },
      { breakpoint: 576, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 384, settings: { slidesToShow: 2, slidesToScroll: 2 } }
    ]
  };

  const className =
    'recommendations' + (props.className ? ` ${props.className}` : '');

  const list = props.list || [];

  return (
    <div className={className}>
      <Carousel {...sliderSettings}>
        {list.map(item => (
          /* container div is required: https://github.com/akiran/react-slick/issues/29 */
          <div key={item.sku_id}>
            <ProductItem
              {...item}
              className="section recommendation-item"
              checkout={props.checkout}
              trackCategory={props.trackCategory}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default Recommendations;



// WEBPACK FOOTER //
// ./shared/components/recommendation/index.js